import { render, staticRenderFns } from "./ProximosPartidos.vue?vue&type=template&id=30ebbbac&"
import script from "./ProximosPartidos.vue?vue&type=script&lang=js&"
export * from "./ProximosPartidos.vue?vue&type=script&lang=js&"
import style0 from "./ProximosPartidos.vue?vue&type=style&index=0&id=30ebbbac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports